import createIcon from '../../createIcon';

/**
 * @component @name Pages
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1VjExSDhMNyA3TDExIDhWM0g1QzMuOSAzIDMgMy45IDMgNVpNOCAxM0gzVjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxMVYxNkw3IDE3TDggMTNaTTE3IDE3TDEzIDE2VjIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxM0gxNkwxNyAxN1pNMTkgM0gxM1Y4TDE3IDdMMTYgMTFIMjFWNUMyMSAzLjkgMjAuMSAzIDE5IDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Pages = createIcon('Pages', [
  [
    'path',
    {
      d: 'M3 5V11H8L7 7L11 8V3H5C3.9 3 3 3.9 3 5ZM8 13H3V19C3 20.1 3.9 21 5 21H11V16L7 17L8 13ZM17 17L13 16V21H19C20.1 21 21 20.1 21 19V13H16L17 17ZM19 3H13V8L17 7L16 11H21V5C21 3.9 20.1 3 19 3Z',
      key: 'a2ftib',
    },
  ],
]);

export default Pages;
